<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark :to="{ name: 'home' }">
        <v-icon>close</v-icon>
      </v-btn>
      <v-btn
        @click="emailTaskNotifications"
        v-if="$keycloak.hasRealmRole('root')"
        >Send email notifications</v-btn
      >
      <v-toolbar-title> <v-icon>event</v-icon>Planner </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <!-- <div>start:{{start}}</div>
      <div>end:{{end}}</div>-->
      <div>
        <v-btn @click="$refs.calendar.prev()">
          <v-icon dark left>keyboard_arrow_left</v-icon>Prev
        </v-btn>
        <v-btn @click="$refs.calendar.next()">
          Next
          <v-icon right dark>keyboard_arrow_right</v-icon>
        </v-btn>
        <v-btn @click="navigateAdd" color="info">
          <v-icon>add</v-icon>
        </v-btn>
        <span style="font-size: 2em; font-weight: bold">{{
          start | formatMonthYear
        }}</span>
      </div>
      <v-chip
        v-for="task in tasksDue"
        :key="`taskDue${task.id}`"
        color="orange"
        text-color="white"
        @click="navigate(task)"
      >
        <v-avatar>
          <v-icon>alarm</v-icon>
        </v-avatar>
        {{ task.taskTitle.body }}
      </v-chip>
      <v-calendar
        ref="calendar"
        v-model="start"
        :type="type"
        :end="end"
        color="primary"
        v-if="computedTasks"
      >
        <template v-slot:day="{ date }">
          <template v-for="task in computedTasks[date]">
            <div
              v-ripple
              :class="task.styleClass"
              v-html="task.title"
              :key="task.id"
              @click="showMenu($event, task)"
            />
          </template>
        </template>
      </v-calendar>
      <v-menu
        v-model="open"
        full-width
        offset-x
        v-if="task"
        :position-x="x"
        :position-y="y"
      >
        <v-card color="grey lighten-4" min-width="350px" flat>
          <v-toolbar color="primary" dark>
            <v-btn @click="navigate(task)" icon v-if="task.mine">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-toolbar-title>
              <span v-if="task.taskTitle">{{ task.taskTitle.body }}</span>
              <span v-if="!task.taskTitle">NO TITLE!</span>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-title primary-title>
            <span v-html="task.description"></span>
          </v-card-title>
          <v-card-text>
            <FileZ v-if="task.file" :file="task.file" />
            <div v-for="entity in task.entities" :key="entity.id">
              <EntityZ :entity="entity" />&#160;
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn flat color="secondary">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <v-checkbox label="Show all" v-model="all" @change="update" />
    </v-card-text>
  </v-card>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import FileZ from "@/components/link/FileZ";
import nbmlaw from "@/api/nbmlaw";
import { nameFormatted } from "@/util/helpers";
export default {
  name: "Planner",
  metaInfo() {
    return {
      title: "Planner",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EntityZ,
    FileZ
  },
  computed: {
    computedTasks() {
      if (!this.tasks) {
        return undefined;
      }
      const tasks = new Object();
      for (const [key, value] of Object.entries(this.tasks)) {
        const result = value.map((t) => {
          let mine = false;
          let title = t.taskTitle ? t.taskTitle.body : "Loading";
          if (t.entities && t.entities.length) {
            title += " (";
            title += t.entities
              .slice(0, 5)
              .map((e) => nameFormatted(e.name, "initials"))
              .join(", ");
            title += t.entities.length > 5 ? " + more)" : ")";
            mine = t.entities
              .map((e) => e.id)
              .includes(this.$keycloak.tokenParsed.entityid);
          }
          let styleClass = "taskNormal ";
          if (mine) {
            styleClass += t.dismiss ? "taskMineDismissed" : "taskMineActive";
          } else {
            styleClass += t.dismiss
              ? "taskTheirsDismissed"
              : "taskTheirsActive";
          }
          return { ...t, title, styleClass, mine };
        });
        tasks[key] = result;
      }
      return tasks;
    }
  },
  data() {
    return {
      all: false,
      tasks: null,
      task: null,
      tasksDue: null,
      type: "month",
      start: null,
      end: null,
      startLong: null,
      endLong: null,
      typeOptions: [
        { text: "Day", value: "day" },
        { text: "4 Day", value: "4day" },
        { text: "Week", value: "week" },
        { text: "Month", value: "month" },
        { text: "Custom Daily", value: "custom-daily" },
        { text: "Custom Weekly", value: "custom-weekly" }
      ],
      x: 0,
      y: 0,
      open: false
    };
  },
  methods: {
    async fetchTasks() {
      const response = await nbmlaw.get(`/cors/admin/directory/tasks`, {
        params: { start: this.startLong, end: this.endLong, all: this.all }
      });
      // console.log(response.data);
      this.tasks = response.data;
    },
    async fetchTasksDue() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/entities/current/tasksDue`
      );
      // console.log(response.data);
      this.tasksDue = response.data;
    },
    async emailTaskNotifications() {
      await nbmlaw.put(`/cors/admin/directory/tasksDue/email`, null);
    },
    navigate(task) {
      this.$emit("navigated");
      this.$router.push({ name: "task", params: { id: task.id } });
    },
    navigateAdd() {
      this.$emit("navigated");
      this.$router.push({ name: "taskAdd" });
    },
    update() {
      this.fetchTasks();
      this.fetchTasksDue();
    },
    showMenu(e, task) {
      this.x = e.clientX;
      this.y = e.clientY;
      this.task = task;
      this.open = true;
    }
  },
  watch: {
    start: {
      handler() {
        const start = new Date(this.start);
        const startLong = new Date(start.setMonth(start.getMonth() - 3));
        this.startLong = startLong.toISOString().substr(0, 10);
        const end = new Date(start.setMonth(start.getMonth() + 1));
        this.end = end.toISOString().substr(0, 10);
        const endLong = new Date(end.setMonth(end.getMonth() + 3));
        this.endLong = endLong.toISOString().substr(0, 10);
        this.update();
      }
    },
    "$route.query.start": {
      immediate: true,
      handler() {
        if (this.$route.query.start) {
          this.start = this.$route.query.start;
        } else {
          const start = new Date();
          start.setDate(1);
          this.start = start.toISOString().substr(0, 10);
        }
      }
    }
  }
};
</script>

<style scoped>
.taskNormal {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  width: 100%;
  cursor: pointer;
  margin-bottom: 1px;
}
.taskMineActive {
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
}
.taskMineDismissed {
  background-color: #cccccc;
  color: #000000;
  border: 1px solid #1867c0;
  font-size: 10px;
  padding: 2px;
  text-decoration: line-through;
}
.taskTheirsActive {
  background-color: #bd6ebd;
  color: #ffffff;
  border: 1px solid #740e74;
  font-size: 10px;
  padding: 3px;
}
.taskTheirsDismissed {
  background-color: #bbbbff;
  color: #000000;
  border: 1px solid #1867c0;
  font-size: 10px;
  padding: 2px;
  text-decoration: line-through;
}
</style>